import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';

import { ScrumboardService } from 'app/main/pages/scrumboard/scrumboard.service';
import { Board } from 'app/main/pages/scrumboard/board.model';
import { ToastrService } from 'ngx-toastr';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ParseService } from 'app/shared/common/parse/parse.service';

@Component({
    selector: 'scrumboard',
    templateUrl: './scrumboard.component.html',
    styleUrls: ['./scrumboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class ScrumboardComponent implements OnInit, OnDestroy {
    boards: any[];
    empRole: any;
    superAccess: boolean = false;
    boardName: string;
    // Private
    private _unsubscribeAll: Subject<any>;
    allowAccess: boolean;

    /**
     * Constructor
     *
     * @param {Router} _router
     * @param {ScrumboardService} _scrumboardService
     */
    constructor(
        private _router: Router,
        private _scrumboardService: ScrumboardService,
        private toastr: ToastrService,
        private storageConfiguration: StorageConfiguration,
        private parseService: ParseService,

    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
     ngOnInit(): void {

        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        if (this.empRole == 'Admin') {
            this.superAccess = true;
        }


        this._scrumboardService.onBoardsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(boards => {
                this.boards = boards;
            });
    }

    searchBoard(event) {
        this._scrumboardService.boardSearch(event.charAt(0).toUpperCase() + event.slice(1));
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void 
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * New board
     */
    newBoard(): void 
    {
        const newBoard = new Board({});
        this._scrumboardService.createNewBoard(newBoard).then(() => {

            this._router.navigate(['scrumboard/boards/' + newBoard.id + '/' + newBoard.uri]);
            // this.toastr.success('Board created Successfully');
        });
    }
}
